import { render, staticRenderFns } from "./NewMail.vue?vue&type=template&id=e3bd8c68&scoped=true&"
import script from "./NewMail.vue?vue&type=script&lang=js&"
export * from "./NewMail.vue?vue&type=script&lang=js&"
import style0 from "./NewMail.vue?vue&type=style&index=0&id=e3bd8c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bd8c68",
  null
  
)

export default component.exports